import { useEffect, useState } from "react";
import GoogleButton from "react-google-button";
import Loading from "../components/Loading";
import { useAuth } from "../hooks/AuthProvider";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";

function Login(props) {
  const [loading, setLoading] = useState(false);
  const [googleToken, setGoogleToken] = useState(null);

  const [loginType, setLoginType] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [emailErrorMsg, setEmailErrorMsg] = useState("");
  const [passwordErrorMsg, setPasswordErrorMsg] = useState("");

  //Enum type for javascript
  const LoginType = Object.freeze({
    STANDARD: { index: 0 },
    GOOGLE: { index: 1 },
  });

  const auth = useAuth();

  const handleStandardLogin = () => {
    setLoginType(LoginType.STANDARD);
    setLoading(true);
  };
  const handleGoogleLogin = () => {
    auth.googleLogin(googleToken);
    setGoogleToken(null);
    setLoading(true);
  };

  const onRegisterClick = () => {
    props.setIsLogin(false);
  };

  useEffect(() => {
    if (googleToken) {
      handleGoogleLogin();
    }
    if (auth.token) {
      setLoading(false);
    }
  }, [googleToken, loading]);

  const googleButton = useGoogleLogin({
    onSuccess: (codeResponse) => setGoogleToken(codeResponse.access_token),
    onError: (error) => console.log("Login Failed: ", error),
  });

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className="Login-Card">
          <div className="Login-Title">Login</div>
          <br />
          <div className="Login-Input">
            <input
              value={email}
              placeholder="Enter your email here"
              onChange={(ev) => {
                setEmail(ev.target.value);
              }}
              className="Input-Box"
            />
            <label className="Label-Error">{emailErrorMsg}</label>
          </div>
          <br />
          <div className="Login-Input">
            <input
              value={password}
              onChange={(ev) => {
                setPassword(ev.target.value);
              }}
              placeholder="Enter your password here"
              className="Input-Box"
            />
            <label className="Label-Error">{passwordErrorMsg}</label>
          </div>
          <br />
          <div className="Login-Buttons">
            <input
              className="Input-Button"
              type="button"
              onClick={() => {
                handleStandardLogin();
              }}
              value="Log In"
            />
            <input
              className="Input-Button"
              type="button"
              onClick={() => onRegisterClick()}
              value="Register"
            />
          </div>
          <br />
          <div>
            <GoogleButton
              onClick={() => {
                googleButton();
              }}
            />
          </div>
        </div>
      )}
    </>
  );
}
export default Login;
